import React, { useState } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import clsx from "clsx";
import * as auth from "../../store/ducks/auth.duck";
import { login } from "../../crud/auth.crud";
import * as utils from "../../../_metronic/utils/utils";
import CustomInput from "../../components/CustomInput";

function Login(props) {
    const [loading, setLoading] = useState(false);

    const enableLoading = () => {
        setLoading(true);
    };

    const disableLoading = () => {
        setLoading(false);
    };

    return (
        <>
            <div className="kt-login__body">
                <div className="kt-login__form">
                    <div className="kt-login__title">
                        <span className="tt-32 semibold color-black">Entrar</span>
                    </div>

                    <Formik
                        initialValues={{ email: "", password: "" }}
                        validate={(values) => {
                            const errors = {};

                            if (!values.email) {
                                errors.email = "O campo email é obrigatório.";
                            } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
                                errors.email = "Você precisa informar um email válido.";
                            }

                            if (!values.password) {
                                errors.password = "O campo senha é obrigatório.";
                            }

                            return errors;
                        }}
                        onSubmit={(values, { setStatus, setSubmitting }) => {
                            enableLoading();

                            login(values.email, values.password)
                                .then((res) => {
                                    disableLoading();

                                    utils.setStorage("authToken", res.data.token);
                                    props.login(res.data);
                                })
                                .catch(() => {
                                    disableLoading();

                                    setSubmitting(false);

                                    setStatus("Usuário ou senha incorretos.");
                                });
                        }}
                    >
                        {({ values, status, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                            <form noValidate={true} autoComplete="off" className="kt-form" onSubmit={handleSubmit}>
                                {status ? (
                                    <div role="alert" className="alert alert-danger">
                                        <div className="alert-text">{status}</div>
                                    </div>
                                ) : null}

                                <div className="form-group">
                                    <CustomInput required margin="normal" inheritLabel label="E-mail" name="email" type="email" value={values.email} handleBlur={handleBlur} handleChange={handleChange} errors={errors} touched={touched} disabled={loading} />
                                </div>

                                <div className="form-group">
                                    <CustomInput required margin="normal" inheritLabel label="Senha" name="password" handleBlur={handleBlur} handleChange={handleChange} errors={errors} touched={touched} disabled={loading} />
                                </div>

                                <div className="kt-login__actions">
                                    <div>
                                        <a href="/password/forgot" className="kt-link kt-login__link-forgot">
                                            Esqueceu a senha?
                                        </a>
                                    </div>

                                    <div>
                                        <button
                                            id="kt_login_signin_submit"
                                            type="submit"
                                            disabled={isSubmitting}
                                            className={`btn btn-primary btn-large kt-login__btn-primary tt-14 semibold color-white d-flex gap-8 ${clsx({ "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": loading })}`}
                                        >
                                            {loading ? null : <i className="fas fa-plus-square" />} Entrar
                                        </button>
                                    </div>
                                </div>
                            </form>
                        )}
                    </Formik>
                </div>
            </div>
        </>
    );
}

export default connect(null, auth.actions)(Login);
